import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder mirroring the categories strip + fields table. */
export const ScorecardFieldsSkeleton: React.FC = () => (
	<div className="space-y-6" aria-hidden="true">
		<div className="flex flex-wrap gap-2">
			{Array.from({ length: 3 }).map((_, index) => (
				<Skeleton key={index} className="h-9 w-40 rounded-sm" />
			))}
		</div>
		<div className="rounded-sm border border-border">
			<div className="border-b border-border p-3">
				<Skeleton className="h-5 w-48" />
			</div>
			<div className="space-y-3 p-3">
				{Array.from({ length: 5 }).map((_, index) => (
					<div key={index} className="flex items-center gap-4">
						<Skeleton className="h-4 w-1/4" />
						<Skeleton className="h-4 w-24" />
						<Skeleton className="h-4 w-16" />
						<Skeleton className="h-4 flex-1" />
						<Skeleton className="h-7 w-24" />
					</div>
				))}
			</div>
		</div>
	</div>
);
